import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-departments',
  imports: [RouterModule],
  templateUrl: './departments.html',
  styleUrl: './departments.scss',
})
export class Departments {}
